import PropTypes from 'prop-types';
import GridOptions from './GridOptions';
import MuiGrid from '../../../../../UI/MuiGrid/MuiGrid';

import {
  formatNumberSR,
  formatPrice,
} from '../../../../../../../utils/FormatPrice';
import { useTranslation } from 'react-i18next';
import { icons } from '../../../../../../../shared/icons';
import { formatDateFromDB } from '../../../../../../../utils/FormatDate';

const GridProvider = ({
  data,
  handleOpenDeleteDialog,
  handleEditData,
  loading,
}) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: t('options'),
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.id)}
          getEditData={() => handleEditData(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    {
      field: 'ceoBrDokSZ',
      headerName: t('docNumber'),
      width: 200,
    },
    {
      field: 'datum',
      headerName: t('date'),
      width: 200,
      valueFormatter: ({ value }) => formatDateFromDB(value),
    },
    {
      field: 'brojCiklusa',
      headerName: t('machineHours'),
      width: 200,

      valueFormatter: ({ value }) => formatNumberSR(value),
    },
    {
      field: 'imeKreirao',
      headerName: t('created'),
      width: 150,
    },
  ];

  return (
    <div style={{ height: '65vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={loading} />
    </div>
  );
};

GridProvider.propTypes = {
  data: PropTypes.array.isRequired,
  handleOpenDeleteDialog: PropTypes.func.isRequired,
  handleEditData: PropTypes.func.isRequired,
};

export default GridProvider;
